import { render, staticRenderFns } from "./ApiMessage.vue?vue&type=template&id=1e1ff0bf&scoped=true&"
import script from "./ApiMessage.vue?vue&type=script&lang=js&"
export * from "./ApiMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1ff0bf",
  null
  
)

export default component.exports